import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { trackEvent } from '@/analytics/events';

function routeGroupForPath(pathname: string) {
  if (pathname === '/') {
    return 'landing';
  }

  return pathname.split('/').filter(Boolean)[0] ?? 'unknown';
}

export function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    trackEvent('app_page_viewed', {
      path: location.pathname,
      route_group: routeGroupForPath(location.pathname),
      has_search_params: Boolean(location.search),
    });
  }, [location.pathname, location.search]);

  return <Outlet />;
}
